import { render, staticRenderFns } from "./NewDraw.vue?vue&type=template&id=44f759f5"
import script from "./NewDraw.vue?vue&type=script&lang=js"
export * from "./NewDraw.vue?vue&type=script&lang=js"
import style0 from "./NewDraw.vue?vue&type=style&index=0&id=44f759f5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports